class frames{
	constructor() {
		
	}
	load(el) {
		el.querySelector('iframe').setAttribute('src', el.querySelector('iframe').getAttribute('data-src'));
	}
}
window.app.add('frames', new frames());